import { CAMERA_CLIP_MODE_NORMAL, CAMERA_CLIP_MODE_VERTICAL } from './constants';
export var CameraClipMode;
(function (CameraClipMode) {
    /**
     * 剪裁上下
     */
    CameraClipMode[CameraClipMode["portrait"] = 1] = "portrait";
    /**
     * 剪裁左右
     */
    CameraClipMode[CameraClipMode["landscape"] = 0] = "landscape";
})(CameraClipMode || (CameraClipMode = {}));
